import { defaultLanguage } from "../constants";
import { MultiLingualState } from "../actions/MultiLingual/types";

import { defaultGetResponse } from "../interfaces/ActionReducer/GetMethod/GetResponse";
import { createReducer } from "@reduxjs/toolkit";
import { getLanguageOptions, receivedLanguageOptions, setCurrentLanguage } from "actions";

const initialState: MultiLingualState = {
    languageOptions: defaultGetResponse,
    isLanguageOptionsReceived: false,
    currentLanguage: defaultLanguage
};
const MultiLingualReducerState = createReducer(initialState, (builder) => {
    builder
        .addCase(getLanguageOptions, (state) => {
            state.isLanguageOptionsReceived = false;
        })
        .addCase(receivedLanguageOptions, (state, action) => {
            state.languageOptions = action.payload.languages;
            state.isLanguageOptionsReceived = true;
        })
        .addCase(setCurrentLanguage, (state, action) => {
            state.currentLanguage = action.payload.currentLanguage;
        })
        .addDefaultCase((state) => state);
});
export default MultiLingualReducerState;
